import ContentConfig from '../../config/ContentConfig';
import LocalState from '../../state/LocalState';
import SDKConfig from '../../common/SDKConfig';
import { NOT_PEERABLE } from '../../common/constants';
import { SendSessionDiagnosticArgs, SendDiagnosticArgs } from './constants';
import { sendSessionDiagnostic } from './sendDiagnostic';
import getAgentId from '../../util/getAgentId';

export interface GenerateDiagnosticArgs {
  code: number;
  nodeId?: string;
  clusterId?: string;
  message?: string;
  state: LocalState;
}

export const generateDiagnosticArgs = (
  args: GenerateDiagnosticArgs
): SendDiagnosticArgs => {
  const {
    code,
    state: { play, reporter }
  } = args;
  const config = ContentConfig.getInstance();
  return {
    agentId: getAgentId(),
    code,
    reporterId: reporter.browserUserGuid,
    statsHost: config.sth as string,
    contentId: play.contentId as string,
    playGuid: play.playGuid as string,
    tenantId: play.tenantId as string,
    token: (reporter.sessionToken || reporter.contentToken) as string
  };
};

export const dispatchSessionDiagnostic = async (
  args: GenerateSessionDiagnosticArgs
): Promise<void> => {
  await sendSessionDiagnostic(generateSessionDiagnosticArgs(args));
};

export const getMessage = (from: string, message?: string): string => {
  const m = [`Origin: ${from}`];
  if (message) {
    m.push(message);
  }
  return m.join('; ');
};

export interface GenerateSessionDiagnosticArgs extends GenerateDiagnosticArgs {
  data?: Record<string, unknown>;
  from: string;
}

export const generateSessionDiagnosticArgs = (
  args: GenerateSessionDiagnosticArgs
): SendSessionDiagnosticArgs => {
  const {
    clusterId,
    data,
    nodeId,
    state: { play, reporter }
  } = args;
  const message = getMessage(args.from, args.message);
  return {
    ...generateDiagnosticArgs(args),
    data,
    app: new SDKConfig().integrationName(),
    clusterId: clusterId || reporter.activeClusterId || NOT_PEERABLE,
    contentId: play.contentId as string,
    localities: ContentConfig.getInstance().localities || [],
    nodeId: nodeId || reporter.nodeId || NOT_PEERABLE,
    sessionId: play.playGuid as string, // TODO: wire in correct field
    message,
    token: (reporter.sessionToken || reporter.contentToken) as string
  };
};
